module.exports = __webpack_public_path__ + "media/images/login_icon-5358bc3ab3ab6bd4945c69e4e072414c.png";